import { configureStore } from "@reduxjs/toolkit";
import mandateReducer from "../features/mandateSlice.js";

export const store = configureStore({
  reducer: {
    mandate: mandateReducer,
  },
});

export default store;
